import React, { useContext } from 'react';
import AppContext from '../context/Context';
import ComplainRoutes from '../routes/ComplainRoutes';

const ComplainLayout = () => {
    const { isFluid } = useContext(AppContext);

    return  <div className={isFluid ? 'container-fluid' : 'container'}>
                <ComplainRoutes />
            </div>
}

export default ComplainLayout;